'use client';

import { useRouter } from 'next/navigation';

import { Button, Container } from '@/components/ui';
import type { z } from '@/libs';
import { ROUTES } from '@/types/enums';

const NotFoundPage = () => {
  const router = useRouter();

  const handleGoHome = () => {
    const home: z.infer<typeof ROUTES> = ROUTES.enum['/'];
    router.push(home);
  };

  return (
    <Container className="flex min-h-screen items-center justify-center py-4 md:py-0">
      <div className="flex-1 md:flex-none flex flex-col items-center md:min-h-[50vh]">
        <div className="flex-1 flex flex-col items-center justify-center gap-2">
          <h1 className="text-6xl md:text-8xl font-extrabold text-primary">404</h1>
          <h2 className="text-base md:text-xl font-semibold">Página não encontrada</h2>
          <p className="text-sm md:text-base text-center">
            A página que você está procurando não existe.
          </p>
        </div>

        <div className="flex-1 flex flex-col-reverse md:flex-row md:justify-center w-full gap-2">
          <Button variant="secondary" size="large" onClick={handleGoHome}>
            Voltar ao início
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default NotFoundPage;
